import { render, staticRenderFns } from "./PostTopicPanel.vue?vue&type=template&id=bbdf536a&scoped=true&"
import script from "./PostTopicPanel.vue?vue&type=script&lang=js&"
export * from "./PostTopicPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdf536a",
  null
  
)

export default component.exports